import EntityStats from "./EntityStats";
import _3DModelDetailLevel from "./enums/_3DModelDetailLevel";
import _3DModelFormat from "./enums/_3DModelFormat";
import _3DModelLicenseType from "./enums/_3DModelLicenseType";
import PathInfo from "./PathInfo";
import Texture from "./Texture";

class _3DInstance {
  constructor(
    public id_user: number,
    public id_e3dmodel: number,
    public id_file: number,
    public icon: number | undefined,
    public name: string,
    public description: string,
    public format: _3DModelFormat,
    public detail_level: _3DModelDetailLevel | undefined,
    public sensor_configuration: string,
    public license_type: _3DModelLicenseType | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: string | undefined,
    public icon_path?: string | undefined,
    public bin_name?: string | undefined,
    public parent?: PathInfo,
    public counts?: EntityStats[] | undefined,
    public username?: string | undefined,
    public texture?: Texture
  ) {}

  public static EmptyInstance(): _3DInstance {
    return new _3DInstance(
      -1,
      -1,
      -1,
      -1,
      "",
      "",
      _3DModelFormat.GLTF,
      undefined,
      "",
      undefined
    );
  }
}

export default _3DInstance;
